const SignUpCarouselDesktop = () => {
  return (
    <div className="flex flex-col items-center h-full my-auto justify-center -mt-24 text-[#ffffff] px-[85px]">
      <div className="font-bold text-[30px] leading-[50px] text-center">
        <p>
          PAYMENT WITHOUT <br /> BORDERS.{" "}
        </p>
        <p>
          SETTLEMENTS WITHOUT <br /> DELAYS.
        </p>
      </div>
    </div>
  );
};

export default SignUpCarouselDesktop;
